import PropTypes from "prop-types";

export const ThreeDotsProps = {
  className: PropTypes.string,
  classNamePopupContent: PropTypes.string,

  icons: PropTypes.array,
  iconTitle: PropTypes.string,

  idButton: PropTypes.string,
  idButton: PropTypes.string,

  isApplyDefault3DotsStylesToPopup: PropTypes.bool,
  isShowIconInTextMode: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  isDotsPositionAfter: PropTypes.bool,
  isMobile: PropTypes.bool,
  textMode: PropTypes.bool,

  widthAvailable: PropTypes.number,
  btnThreeDotsWidth: PropTypes.number,

  onShow: PropTypes.func,

  children: PropTypes.any,
};
